import $ from 'jquery'
import Overlay from 'ol/Overlay'
import Geolocation from 'ol/Geolocation'

const gpsLocationMarker = client => {
  const state = {
    userPositionChangeCounter: 0,
    active: false
  }

  const icon = {
    withHeading: 'fa-location-arrow',
    withoutHeading: 'fa-crosshairs'
  }

  const userPositionMarker = new Overlay({
    positioning: 'center-center',
    element: $(
      `<i style="color:rgba(0, 159, 223, 1);font-size: 2em;" class="fa ${
        icon.withoutHeading
      } icon-only"></i>`
    ).get(0),
    stopEvent: false,
    autoPan: true,
    autoPanMargin: 150,
    autoPanAnimation: {
      duration: 0
    }
  })

  const userPositionGeolocation = new Geolocation({
    trackingOptions: {
      enableHighAccuracy: true
    },
    projection: client.map.getView().getProjection()
  })

  userPositionGeolocation.on('change', e => {
    const position = userPositionGeolocation.getPosition()
    const element = userPositionMarker.getElement()
    const headingIconOffset = -0.765
    const heading = userPositionGeolocation.getHeading()

    userPositionMarker.setPosition(position)

    // Reset icon
    element.classList.remove(icon.withHeading, icon.withoutHeading)

    // Set icon and rotate based on heading
    if (heading !== undefined) {
      element.classList.add(icon.withHeading)
      const headingWithOffset = heading + headingIconOffset
      element.style.transform = `rotate(${headingWithOffset}rad)`
    } else {
      element.classList.add(icon.withoutHeading)
      element.style.transform = `rotate(0rad)`
    }

    if (state.userPositionChangeCounter === 0) {
      client.map.getView().setCenter(position)
    }
    state.userPositionChangeCounter++
  })

  /* Cordova: Disable tracking when app is in background mode */
  document.addEventListener(
    'pause',
    () => userPositionGeolocation.setTracking(false),
    false
  )

  /* Cordova: Resume tracking when app resumes */
  document.addEventListener(
    'resume',
    () => userPositionGeolocation.setTracking(state.active),
    false
  )

  const activate = () => {
    state.active = true
    state.userPositionChangeCounter = 0
    client.map.addOverlay(userPositionMarker)
    userPositionGeolocation.setTracking(state.active)
  }

  const deactivate = () => {
    state.active = false
    userPositionGeolocation.setTracking(state.active)
    client.map.removeOverlay(userPositionMarker)
  }

  const toggle = () => {
    if (state.active) {
      deactivate()
    } else {
      activate()
    }
    $('#gpsToggle')
      .find('i')
      .toggleClass('active')
  }

  return {
    activate,
    deactivate,
    toggle
  }
}

export default gpsLocationMarker
